import BtnInMobileNavBar from "./modules/btnInMobileNavBar";
import CustomizableSwiper from "./modules/customizableSlider";
import CursorTrail from "./connect_engineer_modules/cursorTrail";

const btnInMobileNavBar = new BtnInMobileNavBar(620);
const cursorTrail = new CursorTrail();

function prepareSlides() {
    return new Promise((resolve) => {
        const sliderContainer = document.querySelector(".s-training__content-container");
        if (window.innerWidth < 1240) {
            sliderContainer.innerHTML += `<div class="swiper-slide s-training__slide s-training__slide-unlock-on-tablet">
                        <picture class="s-training__picture">
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guy-on-left-img.webp" width="416" height="413" media="(min-width: 716px)" type="image/webp"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guy-on-left-img-mobile.webp" width="328" height="337" media="(max-width: 715px)" type="image/webp"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guy-on-left-img.png" width="416" height="413" media="(min-width: 716px)" type="image/png"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guy-on-left-img-mobile.png" width="328" height="337" media="(max-width: 715px)" type="image/png"/>
                            <img loading="lazy" class="s-training__img" src="/img/career/connect-engineer/ce-training-slider-guy-on-left-img.png" alt="desc-swiper-guy-on-left"/>
                        </picture>
                    </div>
                    <div class="swiper-slide s-training__slide s-training__slide-unlock-on-tablet">
                        <picture class="s-training__picture">
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guys-hands-img.webp" width="639" height="413" media="(min-width: 716px)" type="image/webp"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guys-hands-img-mobile.webp" width="328" height="337" media="(max-width: 715px)" type="image/webp"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guys-hands-img.png" width="639" height="413" media="(min-width: 716px)" type="image/png"/>
                            <source srcset="/img/career/connect-engineer/ce-training-slider-guys-hands-img-mobile.png" width="328" height="337" media="(max-width: 715px)" type="image/png"/>
                            <img loading="lazy" class="s-training__img" src="/img/career/connect-engineer/ce-training-slider-guys-hands-img.png" alt="desc-swiper-guys-hands"/>
                        </picture>
                    </div>`;
        }
        resolve();
    });
}

function initSlider() {
    const descriptionSlider = new CustomizableSwiper(
        '.js-training-slider',
        {
            slidesPerView: "auto",
            preloadImages: false,
            // loop: true,
            spaceBetween: (window.innerWidth < 1240 ? 300 : 30),
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true
            }
        }
    );

}

prepareSlides().then(() => {
    initSlider();
});
